import transaction from '../transaction'
import search from '../search'
import user from '../user'
import company from '../company'
import session from '../session'

export default {
  company,
  search,
  session,
  transaction,
  user,
}



/** WEBPACK FOOTER **
 ** ./lib/client/resources.js
 **/